import React from "react";

function NXWarehouse({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="23"
      height="24"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4287_2844)">
        <path
          d="M13.5 6.94C13.501 6.8012 13.473 6.66372 13.4179 6.53632C13.3628 6.40892 13.2818 6.29438 13.18 6.2L7.00002 0.5L0.820023 6.2C0.718248 6.29438 0.637236 6.40892 0.582143 6.53632C0.52705 6.66372 0.499084 6.8012 0.500023 6.94V12.5C0.500023 12.7652 0.60538 13.0196 0.792916 13.2071C0.980452 13.3946 1.23481 13.5 1.50002 13.5H12.5C12.7652 13.5 13.0196 13.3946 13.2071 13.2071C13.3947 13.0196 13.5 12.7652 13.5 12.5V6.94Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.249 10.001H7.25C7.11193 10.001 7 10.1129 7 10.251V13.25C7 13.388 7.11193 13.5 7.25 13.5H10.249C10.3871 13.5 10.499 13.388 10.499 13.25V10.251C10.499 10.1129 10.3871 10.001 10.249 10.001Z"

          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.499 6.50098H5.5C5.36193 6.50098 5.25 6.61291 5.25 6.75098V9.74998C5.25 9.88805 5.36193 9.99998 5.5 9.99998H8.499C8.63707 9.99998 8.749 9.88805 8.749 9.74998V6.75098C8.749 6.61291 8.63707 6.50098 8.499 6.50098Z"

          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75001 10.001H3.75101C3.61294 10.001 3.50101 10.1129 3.50101 10.251V13.25C3.50101 13.388 3.61294 13.5 3.75101 13.5H6.75001C6.88808 13.5 7.00001 13.388 7.00001 13.25V10.251C7.00001 10.1129 6.88808 10.001 6.75001 10.001Z"

          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4287_2844">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXWarehouse;
